import { queryClient } from '@thought-river/negotiations-common';
import { ContractTree } from '@thought-river/negotiations-common/dist/api/contractManagement';
import isEqual from 'lodash/isEqual';
import { useEffect } from 'react';
import {
    IUploadedFile,
    ProcessStatus,
} from './ContractUploadWizardModal-types';

interface PartyDetectionListenerProps {
    contractFile: IUploadedFile;
    onPartiesDetected: () => void;
}

const PartyDetectionListener = ({
    contractFile,
    onPartiesDetected,
}: PartyDetectionListenerProps) => {
    useEffect(() => {
        const { contractId, processStatus } = contractFile;

        if (processStatus !== ProcessStatus.PROCESSING) {
            return;
        }

        const contractsQueryData = queryClient.getQueryData<ContractTree>([
            'contracts',
        ]);

        if (isAwaitingPartyConfirmation(contractId, contractsQueryData)) {
            onPartiesDetected();
        } else {
            const unsubscribe = queryClient
                .getQueryCache()
                .subscribe((event) => {
                    console.log('Subscribing to query cache');
                    if (
                        event.type === 'updated' &&
                        event.action.type === 'success' &&
                        isEqual(event.query.queryKey, ['contracts'])
                    ) {
                        if (
                            isAwaitingPartyConfirmation(
                                contractId,
                                event.action.data as ContractTree
                            )
                        ) {
                            onPartiesDetected();
                        }
                    }
                });

            return () => unsubscribe();
        }
    }, [contractFile, onPartiesDetected]);

    return null;
};

const isAwaitingPartyConfirmation = (
    contractId: string,
    contractsTreeData?: ContractTree
) => {
    const targetContract = contractsTreeData?.rows.find(
        (row) => row.contract_uuid === contractId
    );
    const partyConfirmationStep = targetContract?.processing_steps?.find(
        (step) => step.name === 'party_confirmation'
    );
    return partyConfirmationStep?.status === 'in_progress';
};

export default PartyDetectionListener;
